export const enum CookiesName {
  Token = 'token'
}

export function setCookie(name: CookiesName, value: string, days: number) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  // remove Secure to test cookie in local
  document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Strict; Secure'
}

export function getCookie(name: CookiesName) {
  const searchName = name + '='
  const rawCookies = document.cookie.split(';')
  for (let i = 0; i < rawCookies.length; i++) {
    let currentCookie = rawCookies[i]
    while (currentCookie.charAt(0) == ' ') currentCookie = currentCookie.substring(1, currentCookie.length)
    if (currentCookie.indexOf(searchName) == 0) return currentCookie.substring(searchName.length, currentCookie.length)
  }
  return null
}

export function eraseCookie(name: CookiesName) {
  document.cookie = name + '=; Max-Age=-99999999; path=/'
}
